import { createContactMutation } from '@akin-home/contacts/frontend';
import { contactsQueryKeySet } from '@akin-home/contacts/react';
import { QueryClient } from 'react-query';
import { createOutputTextItem } from '../../ChatItem/functions';
import { AddChatItemFunction } from '../../types';
import { AddContactCommand } from '../types';

interface Params {
  habitatID: string;
  query_client?: QueryClient;
  command: AddContactCommand;
  addItem?: AddChatItemFunction;
}

export const addContactCommand = async (params: Params) => {
  const {
    habitatID,
    command: { data },
    addItem,
    query_client,
  } = params;

  const input = {
    name: data.name || '',
    habitatID,
    email: data.email,
    phoneNumbers: data.phone_number
      ? [{ number: data.phone_number, type: 'mobile' }]
      : undefined,
  };

  try {
    const res = await createContactMutation({ input });

    if (res.errors?.length) {
      throw Error(res.errors[0].message);
    }

    query_client?.invalidateQueries(contactsQueryKeySet.lists());
    query_client?.invalidateQueries(contactsQueryKeySet.all_pages());

    addItem?.(
      createOutputTextItem(
        data.success_message || `Created ${data.name} as a contact`
      )
    );
  } catch (ex: any) {
    addItem?.(
      createOutputTextItem(
        data.error_message || `Sorry, I couldn't add that contact`
      )
    );
  }
};
